import React, { createContext, useContext, useState, useCallback } from 'react';

const MixerContext = createContext(null);

export const MIXER_DEFAULTS = {
  technicalVsBusiness: 50, // 0 = Technical, 100 = Business
  icVsLeadership: 50,      // 0 = IC, 100 = Leadership
  consultingVsEnterprise: 50, // 0 = Consulting, 100 = Enterprise
};

export function MixerProvider({ children }) {
  const [mixerState, setMixerState] = useState(MIXER_DEFAULTS);
  const [viewMode, setViewMode] = useState('live'); // 'live' | 'archive'
  
  const updateSlider = useCallback((key, value) => {
    setMixerState(prev => ({ ...prev, [key]: value }));
  }, []);
  
  const resetMixer = useCallback(() => {
    setMixerState(MIXER_DEFAULTS);
  }, []);
  
  const toggleViewMode = useCallback(() => {
    setViewMode(prev => prev === 'live' ? 'archive' : 'live');
  }, []);
  
  // Calculate interpolation factor (0-1) for content blending
  const getBlendFactor = useCallback((key) => {
    return mixerState[key] / 100;
  }, [mixerState]);
  
  const value = {
    mixerState,
    viewMode,
    updateSlider,
    resetMixer,
    toggleViewMode,
    getBlendFactor,
  };
  
  return (
    <MixerContext.Provider value={value}>
      {children}
    </MixerContext.Provider>
  );
}

export function useMixer() {
  const context = useContext(MixerContext);
  if (!context) {
    throw new Error('useMixer must be used within a MixerProvider');
  }
  return context;
}
